/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line consistent-default-export-name/default-import-match-filename
import coreTokens from '@betterplace/design-tokens/core.json'
import { TokenName } from './types'

export const buildBackgroundStyles = (color: string) => {
  if (color.substring(1, 3) === '00' && color.length === 9) {
    return `url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABlBMVEX////Z5exdL3Q7AAAAGklEQVQY02NgAAFGRkaa0gzo4gzo6hgGiTsANBAAYf1ZdsIAAAAASUVORK5CYII=')`
  } else {
    return color
  }
}

export function getTokenColorHex(tokenName: TokenName) {
  const result = coreTokens[tokenName]
  if (typeof result !== 'object' && typeof result !== 'number') {
    return result
  }
  return '#'
}
